/**
 * Enum label mappings for frontend display.
 * These convert numeric enum values from the backend into human-readable strings.
 */

// ============================================
// SubscriptionStatus
// ============================================
export const SubscriptionStatusLabels: Record<number, string> = {
    0: 'AlreadyActive',
    1: 'Created',
    2: 'NotActive',
    3: 'Error',
};

// ============================================
// Gender
// ============================================
export const GenderLabels: Record<number, string> = {
    0: 'Boy',
    1: 'Girl',
    2: 'PreferNotToSay',
};

// ============================================
// OrderStatus
// ============================================
export const OrderStatusLabels: Record<number, string> = {
    0: 'Pending',
    1: 'Paid',
    2: 'Processing',
    3: 'Shipped',
    4: 'InTransit',
    5: 'Delivered',
    6: 'Problem',
    7: 'Cancelled',
    8: 'Refunded',
    9: 'Completed',
};

// ============================================
// PaymentStatus
// ============================================
export const PaymentStatusLabels: Record<number, string> = {
    0: 'Pending',
    1: 'Authorized',
    2: 'Captured',
    3: 'Failed',
    4: 'Refunded',
    5: 'Paid',
};

// ============================================
// ProductCondition (admin tables — mirror shop filter.condition.* EN fallbacks)
// ============================================
export const ProductConditionLabels: Record<number, string> = {
    0: 'New',
    1: 'Like New', // LikeNew
    2: 'Good',
    3: 'Fair',
    4: 'Poor',
};

// ============================================
// ProductStatus
// ============================================
export const ProductStatusLabels: Record<number, string> = {
    0: 'PendingReview',
    1: 'Active',
    2: 'Rejected',
    3: 'Sold',
    4: 'Archived',
};

// ============================================
// SpecificationType
// ============================================
export const SpecificationTypeLabels: Record<number, string> = {
    0: 'String',
    1: 'Integer',
    2: 'Decimal',
    3: 'Boolean',
    4: 'Enum',
    5: 'Date',
};

// ============================================
// AccountStatus
// ============================================
export const AccountStatusLabels: Record<number, string> = {
    0: 'OK',
    1: 'Warning',
    2: 'Suspended',
    3: 'Banned',
};

// ============================================
// Combined map for dynamic lookup in renderSmartCell
// ============================================
export const AllEnumLabels: Record<string, Record<number, string>> = {
    subscriptionstatus: SubscriptionStatusLabels,
    gender: GenderLabels,
    orderstatus: OrderStatusLabels,
    paymentstatus: PaymentStatusLabels,
    productcondition: ProductConditionLabels,
    productstatus: ProductStatusLabels,
    specificationtype: SpecificationTypeLabels,
    status: AccountStatusLabels,           // covers AccountStatus + general "status" fields
};